window.__locale__ = {
  locale: 'ja',
  localeData: require('react-intl/locale-data/ja'),
  isDummyLocale: false,
  messages: require('./translations/ja.json'),
};
